import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { loadingStore, userSettingsStore, useTranslation } from '@pascal/pascal-core';

import { globalTranslationKeys } from '../../../enums';
import { TutorialCashOutStates } from '../tutorialCashOutStates';
import { specificLocalStorageKeys } from '../../../enums/uiConfig';

export const TutorialStepsPopUps = observer(() => {
  const tutorialArr = [0, 1, 2];

  const t = useTranslation();
  const { timerFinished } = loadingStore;
  const {
    selectedGameTypeId,
    setGameSpecificLocalStorageDataByKey,
    gameSpecificLocalStorageData: { isShowTutorialPopUps },
  } = userSettingsStore;
  const [isShowTutorial, setIsShowTutorial] = useState(false);
  const [tutorialStep, setTutorialStep] = useState(1);

  useEffect(() => {
    if (timerFinished && !isShowTutorialPopUps && selectedGameTypeId) {
      setIsShowTutorial(true);
    }
  }, [selectedGameTypeId, isShowTutorialPopUps, timerFinished]);

  return isShowTutorial ? (
    <div className='tutorial-popup'>
      <div className='steps-popups-container'>
        <div className='steps-popups-wrapper'>
          <div className='steps-popups'>
            <button
              className='close-btn-popups'
              onClick={() => {
                setIsShowTutorial(false);
                setGameSpecificLocalStorageDataByKey(
                  specificLocalStorageKeys.isShowTutorialPopUps,
                  true
                );
              }}
            >
              <i className='ui-lib-Close-fig' />
            </button>
            <h1 className='steps-text'>{`${t(globalTranslationKeys.Step)} ${tutorialStep}`}</h1>
            <p className='steps-info-text'>{t(`STEP_${tutorialStep}`)}</p>
            <div className='steps-arrow-block'>
              <div
                className={`steps-arrow-block-items left ${tutorialStep === 1 ? 'disabled' : ''}`}
                onClick={() => setTutorialStep(tutorialStep - 1)}
              />
              {tutorialStep < 3 ? (
                <div
                  className='steps-arrow-block-items right'
                  onClick={() => setTutorialStep(tutorialStep + 1)}
                />
              ) : (
                <span
                  className='steps-finished-play-text'
                  onClick={() => {
                    setIsShowTutorial(false);
                    setGameSpecificLocalStorageDataByKey(
                      specificLocalStorageKeys.isShowTutorialPopUps,
                      true
                    );
                  }}
                >
                  {t(globalTranslationKeys.Play)}
                </span>
              )}
            </div>
          </div>
          <span className='popup-plane' />
        </div>
        <div className='jets-items-blocks'>
          {tutorialArr.map((item) => (
            <div className='jets-items'>
              <div
                className={`jets-items-bg type-${item + 1} ${
                  tutorialStep === 3 || (tutorialStep === 2 && item !== 1) ? 'disabled' : ''
                }`}
              />
              <div
                className={`jet-btn-text type-${
                  tutorialStep === 2 && item !== 1 ? 'lose' : item + 1
                } ${tutorialStep === 3 ? 'disabled' : ''}`}
              />
            </div>
          ))}
        </div>
        <TutorialCashOutStates tutorialData={tutorialArr} t={t} tutorialStep={tutorialStep} />
      </div>
    </div>
  ) : (
    <></>
  );
});
